export default "__VITE_ASSET__Bx2UK3sc__"